var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { class: `${_vm.block}` },
    [
      _c("nav", { class: `${_vm.block}__${_vm.navElement}` }, [
        _c(
          "ul",
          { class: `${_vm.block}__${_vm.navListElement}` },
          _vm._l(_vm.tabs, function (tabTitle, tab) {
            return _c(
              "li",
              {
                key: tab,
                class: [`${_vm.block}__${_vm.tabElement}`, _vm.isActive(tab)],
              },
              [
                _c("button", {
                  class: `${_vm.block}__${_vm.buttonElement}`,
                  attrs: {
                    id: tab,
                    tabindex: _vm.isFocusedTab(tab) ? "0" : "-1",
                    role: "button",
                    "aria-selected": `${_vm.isActive(tab)}`,
                    "aria-controls": `${tab}-panel`,
                  },
                  domProps: { textContent: _vm._s(tabTitle) },
                  on: {
                    click: function ($event) {
                      return _vm.selectTab(tab)
                    },
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.selectTab(tab)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        )
                          return null
                        return _vm.selectTab(tab)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "right", 39, $event.key, [
                            "Right",
                            "ArrowRight",
                          ])
                        )
                          return null
                        if ("button" in $event && $event.button !== 2)
                          return null
                        _vm.vertical ? null : _vm.navigateNextTab($event)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "left", 37, $event.key, [
                            "Left",
                            "ArrowLeft",
                          ])
                        )
                          return null
                        if ("button" in $event && $event.button !== 0)
                          return null
                        _vm.vertical ? null : _vm.navigatePrevTab($event)
                      },
                    ],
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "down", 40, $event.key, [
                            "Down",
                            "ArrowDown",
                          ])
                        )
                          return null
                        _vm.vertical ? _vm.navigateNextTab($event) : null
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "up", 38, $event.key, [
                            "Up",
                            "ArrowUp",
                          ])
                        )
                          return null
                        _vm.vertical ? _vm.navigatePrevTab($event) : null
                      },
                    ],
                    focus: function ($event) {
                      return _vm.setFocusTab(tab)
                    },
                  },
                }),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.tabs, function (tabTitle, tab) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActiveTab(tab),
                expression: "isActiveTab(tab)",
              },
            ],
            key: tab,
            class: `${_vm.block}__${_vm.panelElement}`,
            attrs: {
              id: `${tab}-panel`,
              tabindex: "0",
              hidden: !_vm.isActiveTab(tab),
              "aria-labelledby": tab,
            },
          },
          [_vm._t(`tab-panel-${tab}`)],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }